// only allow these values for ENVIRONMENT, otherwise abort
const allowedEnvironmentValues = [
  'test-automation',
  'development',
  'staging',
  'production',
]

// Determine 'test-automation' environment automatically if NODE_ENV is 'test'
const testAutomation =
  process.env.NODE_ENV === 'test' ? 'test-automation' : undefined
const rawEnvironment = (process.env.ENVIRONMENT ?? testAutomation)
  ?.trim()
  .toLowerCase()
if (
  !rawEnvironment ||
  !allowedEnvironmentValues.includes(rawEnvironment || '')
) {
  throw new Error(
    `Invalid environment value: ${
      process.env.ENVIRONMENT
    }. Must be one of ${allowedEnvironmentValues.join(', ')}`,
  )
}

export const ENVIRONMENT = rawEnvironment as
  | 'test-automation'
  | 'development'
  | 'staging'
  | 'production'

export const AZURE_TENANT_ID = process.env.AZURE_TENANT_ID || ''
export const AZURE_APPLICATION_CLIENT_ID =
  process.env.AZURE_APPLICATION_CLIENT_ID || ''
export const AZURE_APPLICATION_SCOPE = process.env.AZURE_APPLICATION_SCOPE || ''
export const AZURE_REDIRECT_URI = process.env.AZURE_REDIRECT_URI || ''
export const AZURE_AUTHORITY_HOST = process.env.AZURE_AUTHORITY_HOST || ''

export const API_BASE_URL = process.env.API_BASE_URL

export const SENTRY_DSN = process.env.SENTRY_DSN
export const SENTRY_RELEASE = process.env.SENTRY_RELEASE
export const SENTRY_TRACES_SAMPLE_RATE = parseFloat(
  process.env.SENTRY_TRACES_SAMPLE_RATE || '0',
)

const sentryTracePropagationTargets =
  process.env.SENTRY_TRACE_PROPAGATION_TARGETS?.split(',').map((target) => {
    return new RegExp(target.trim())
  })

export const SENTRY_TRACE_PROPAGATION_TARGETS = sentryTracePropagationTargets

export const SENTRY_REPLAY_SESSION_SAMPLE_RATE = parseFloat(
  process.env.SENTRY_REPLAY_SESSION_SAMPLE_RATE || '0',
)
export const SENTRY_REPLAY_ON_ERROR_SAMPLE_RATE = parseFloat(
  process.env.SENTRY_REPLAY_ON_ERROR_SAMPLE_RATE || '0',
)
export const SENTRY_DEBUG = process.env.SENTRY_DEBUG === 'true'

export const MUI_X_LICENSE_KEY = process.env.MUI_X_LICENSE_KEY
